
App.web_subscribes = {

  select_text_tab() {
    $('#join-by-email').hide();
    $('#join-by-text').show();
    $('#join-by-email').removeClass('active in');
    return $('#join-by-text').addClass('active in');
  },

  select_email_tab() {
    $('#join-by-email').show();
    $('#join-by-text').hide();
    $('#join-by-email').addClass('active in');
    return $('#join-by-text').removeClass('active in');
  },

  select_tab() {
    return App.ready(function() {
      if (location.hash === "#email") {
        return $(".js-email-trigger").click();
      }
    });
  }
};
